import { createFileRoute } from '@tanstack/react-router'
import { LoginPage } from '@/pages/auth/ui/LoginPage'

export const Route = createFileRoute('/auth/login')({
  component: LoginPage,
})
